import { Link } from "react-router-dom";
import { MODES } from "../stacks/constants";
import { ModeMiniGrid, isStrictMode } from "../stacks/ModeIcon";

function Play() {
  return (
    <div className="play-page">
      <div className="study-header">
        <p className="study-eyebrow">Wordy Whiz · Play</p>
        <h1>Choose a way to play</h1>
      </div>

      <div className="mode-grid">
        {Object.values(MODES).map((mode) => (
          <Link key={mode.id} to={`/wordy-whiz/stacks/${mode.id}`} className="mode-card">
            <ModeMiniGrid mode={mode} />
            <span className="mode-card__name">{mode.name}</span>
            <span className="mode-card__tagline">{mode.tagline}</span>
            {isStrictMode(mode) && <span className="mode-card__strict">Strict · No partial credit</span>}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Play;
